import { Slice } from '@lglp/prismic-client';

import { DocumentType } from '../document';

export enum HubSliceType {
  HUB = 'hub',
}

export type HubSlice = Slice & {
  filters: Record<string, boolean>;
  parentType: DocumentType;
};
